var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node-spacer",class:_vm.item.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }